import { apiFetch, ApiError } from './client'
import {
  tokenResponseSchema,
  userResponseSchema,
  type TokenResponse,
  type UserResponse,
} from '@/lib/schemas/auth'

export type LoginRequest = { username: string; password: string }

/** POST /api/auth/login — credentials → JWT + user. */
export async function login(creds: LoginRequest): Promise<TokenResponse> {
  const res = await apiFetch('/api/auth/login', {
    method: 'POST',
    body: JSON.stringify(creds),
  })
  if (!res.ok) {
    const detail = await readDetail(res)
    throw new ApiError(res.status, detail ?? `Login failed (${res.status})`, detail)
  }
  return tokenResponseSchema.parse(await res.json())
}

/** GET /api/auth/me — token check → current user. */
export async function getMe(): Promise<UserResponse> {
  const res = await apiFetch('/api/auth/me', { method: 'GET' })
  if (!res.ok) {
    throw new ApiError(res.status, `Auth check failed (${res.status})`)
  }
  return userResponseSchema.parse(await res.json())
}

async function readDetail(res: Response): Promise<string | undefined> {
  try {
    const body = (await res.json()) as { detail?: string }
    return body?.detail
  } catch {
    return undefined
  }
}
